var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var PlusCircle = function (_a) {
    var props = __rest(_a, []);
    return (_jsxs("svg", __assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsxs("g", __assign({ clipPath: "url(#clip0_6640_98841)" }, { children: [_jsx("circle", { r: "10.0833", transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 12.0002 12.4121)", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }), _jsx("line", { x1: "16", y1: "12.4121", x2: "8", y2: "12.4121", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }), _jsx("line", { x1: "12", y1: "16.4121", x2: "12", y2: "8.41211", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })] })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: "clip0_6640_98841" }, { children: _jsx("rect", { width: "24", height: "24", fill: "white", transform: "translate(24 24.4121) rotate(-180)" }) })) })] })));
};
